var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6133 6.36367C11.3204 6.65656 10.8456 6.65656 10.5527 6.36366L7.74972 3.56067L7.74971 12.25C7.74971 12.6642 7.41393 13 6.99971 13C6.5855 13 6.24971 12.6642 6.24971 12.25L6.24972 3.56066L3.44671 6.36366C3.15382 6.65656 2.67895 6.65656 2.38605 6.36366C2.09316 6.07077 2.09316 5.5959 2.38605 5.303L6.46939 1.21967C6.61004 1.07902 6.8008 0.999999 6.99972 1C7.19863 1 7.3894 1.07902 7.53005 1.21967L11.6133 5.30301C11.9062 5.5959 11.9062 6.07077 11.6133 6.36367Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default "/Frontend/static/media/arrow-up.db56e2d80095c8a5ad8d5afd7685065f.svg";
export { ForwardRef as ReactComponent };